import {systemAuditLogControllerSearch} from "../../api/generated";

// SYSTEM_ADMIN only — backed by the server's SystemAuditLogController (/system/audit-log/*).
// Migrated to the OpenAPI-generated client: auth + timezone come from configureApi's interceptor
// (per-call token read removed). The spec models this list with FLAT pageId/pageSize query params
// (not a nested Pageable), so it migrates cleanly. The endpoint returns PageAuditLogDto
// UN-enveloped, so `data` == the old axios `response.data` and the caller keeps reading
// `res.data.content` / `.totalElements` / `.totalPages`.
export async function getAuditLogs(pageId = 0, pageSize = 30, filters = {}) {
  const query = {pageId, pageSize};
  if (filters.action) {
    query.action = filters.action;
  }
  if (filters.keyword) {
    query.keyword = filters.keyword;
  }
  if (filters.subjectUserId) {
    query.subjectUserId = filters.subjectUserId;
  }
  if (filters.actorUserId) {
    query.actorUserId = filters.actorUserId;
  }

  const {data, error} = await systemAuditLogControllerSearch({query});
  if (error) throw error;
  return {data};
}
